import { Component, Inject, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { DeviceStatus } from 'app/modules/admin/models/devices.types';
import { WebSocketService } from '../../services/websocket.service';

@Component({
  selector: 'app-routine-detonator-device-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  templateUrl: './routine-detonator-device-modal.component.html',
  styleUrls: ['./routine-detonator-device-modal.component.scss'],
})
export class RoutineDetonatorDeviceModalComponent implements OnInit {
  searchTerm: string = '';
  filteredDevices: any[] = [];

  getDeviceLabel(device: any): string {
    if (Array.isArray(device.alias)) {
      return device.alias[0]?.alias || device.serial || 'Sin alias';
    }
    if (typeof device.alias === 'object' && device.alias?.alias) {
      return device.alias.alias;
    }
    return device.alias || device.serial || 'Sin alias';
  }
  devicesStatus: DeviceStatus[];
  constructor(
    public dialogRef: MatDialogRef<RoutineDetonatorDeviceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      availableDevices: any[];
      currentDeviceId: number | null;
    },
    private wsService: WebSocketService
  ) {
  }

  assign(deviceId: number) {
    this.dialogRef.close({ action: 'assign', deviceId });
  }
  unassign() {
    this.dialogRef.close({ action: 'unassign' });
  }
  onFinderClick(deviceId: number) {
    // No cerramos el modal, solo emitimos un evento
    this.dialogRef.componentInstance.finderRequest.emit(deviceId);
  }

  // Evento que será capturado desde fuera para activar el finder sin cerrar el modal
  finderRequest = new EventEmitter<number>();

  ngOnInit(): void {
    // Inicializar dispositivos filtrados
    this.filteredDevices = this.data.availableDevices || [];

    // Suscribirse al observable para recibir actualizaciones en tiempo real
    this.wsService.getDevicesStatus().subscribe({
      next: (devices) => {
        this.devicesStatus = devices;
      },
      error: (err) => {
        console.error('Error loading devices status in modal:', err);
      }
    });
  }

  /**
   * Filtra los dispositivos según el término de búsqueda
   */
  filterDevices(): void {
    if (!this.searchTerm.trim()) {
      this.filteredDevices = this.data.availableDevices || [];
      return;
    }

    const term = this.searchTerm.toLowerCase().trim();
    this.filteredDevices = (this.data.availableDevices || []).filter(device => {
      const label = this.getDeviceLabel(device).toLowerCase();
      const serial = (device.serial || '').toLowerCase();
      const typeName = (device.type_device?.name || '').toLowerCase();

      return label.includes(term) ||
        serial.includes(term) ||
        typeName.includes(term);
    });
  }

  /**
   * Obtiene el estado de conexión de un dispositivo
   */
  getDeviceConnectionStatus(device: any): 'connected' | 'disconnected' {
    const deviceStatus = this.devicesStatus?.find(ds => ds.uid === device.serial);
    return deviceStatus?.status === 'connected' ? 'connected' : 'disconnected';
  }

  isDeviceValid(device: any): boolean {
    if (!device.license) {
      return false;
    }
    if (device.license.expiration_date === null) {
      return true;
    }
    const today = new Date().toISOString().split('T')[0];
    return device.license.expiration_date >= today;
  }

  getDeviceValidationMessage(device: any): string {
    if (!device.license) {
      return 'Sin licencia';
    }
    if (device.license.expiration_date !== null) {
      const today = new Date().toISOString().split('T')[0];
      if (device.license.expiration_date < today) {
        return 'Licencia vencida';
      }
    }
    return '';
  }

  close() {
    this.dialogRef.close();
  }
}
